var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "color-secondary-6 font-14" }, [
          _vm._v(" Servicio: ")
        ]),
        _c("span", { staticClass: "color-black font-16" }, [
          _vm._v(" " + _vm._s(_vm.data.disciplineDescription) + " ")
        ])
      ]),
      _vm.isVisitType(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Modalidad: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(
                " " +
                  _vm._s(_vm._f("empty")(_vm.data.modalityDescription)) +
                  " "
              )
            ])
          ])
        : _vm._e(),
      _vm.isVisitType(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Frecuencia: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.frecuency)) + " ")
            ])
          ])
        : _vm._e(),
      _vm.isVisitType(_vm.data)
        ? _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Duración: ")
            ]),
            _c("span", { staticClass: "color-black font-16" }, [
              _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.duration)) + " ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-3" }, [
      _c("em", { staticClass: "font-18 color-orange fa fa-info-circle mr-2" }),
      _c("span", { staticClass: "color-black font-16 font-weight-bold" }, [
        _vm._v(" Información Adicional ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }